import { useContext, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import UserContext from "context/UserContext";
import { useGestionCustomers } from "hooks/useGestionCustomers";

export function useGestionCustomer() {
  const { customerId: routeCustomerId } = useParams();
  const { selectedGestionCustomer, setSelectedGestionCustomer } = useContext(UserContext);
  const { gestionCustomers } = useGestionCustomers();

  const customerId = routeCustomerId || selectedGestionCustomer?.id;

  const customer = useMemo(() => {
    if (!customerId) return selectedGestionCustomer;
    return (
      gestionCustomers.find((item) => String(item.id) === String(customerId)) ||
      (String(selectedGestionCustomer?.id) === String(customerId) ? selectedGestionCustomer : null)
    );
  }, [customerId, gestionCustomers, selectedGestionCustomer]);

  useEffect(() => {
    if (!routeCustomerId || gestionCustomers.length === 0) return;
    const match = gestionCustomers.find((item) => String(item.id) === String(routeCustomerId));
    if (match && String(match.id) !== String(selectedGestionCustomer?.id)) {
      setSelectedGestionCustomer(match);
    }
  }, [routeCustomerId, gestionCustomers, selectedGestionCustomer?.id, setSelectedGestionCustomer]);

  return {
    customerId,
    customer,
    customerName: customer?.name ?? "",
    setSelectedGestionCustomer,
  };
}
